import React from 'react';
import MensajeIngles from './../language/en.json';
import {IntlProvider} from 'react-intl';

const langContext = React.createContext();

const LangProvider = ({children}) => {
    // Keep app in English only. No language switching.
    const locale = 'en-US';
    const mensajes = MensajeIngles;

    return (
        <langContext.Provider value={{selectLanguage: () => { /* no-op */ }}}>
            <IntlProvider locale={locale} messages={mensajes}>
                {children}
            </IntlProvider>
        </langContext.Provider>
    );
};

export {LangProvider, langContext};